import React, { CSSProperties, FunctionComponent } from 'react';

import { CTA, Title } from '@gojob/cms';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

import Button from '../../Buttons/Button';
import CheeryTitle from '../../CheeryTitle';

interface TextContentsProps {
  title?: Title;
  description?: string;
  cta?: CTA;
  className?: string;
  style?: CSSProperties;
}

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      rowGap: spacing(4),
    },
    cta: {
      alignSelf: 'center',
      width: '100%',
      maxWidth: breakpoint.values.sm,
      boxSizing: 'border-box',
    },
    description: {
      '& strong': {
        fontWeight: 500,
      },
    },
  } as const;
};

const TextContents: FunctionComponent<TextContentsProps> = (props) => {
  const { title, description, cta, className, style } = props;
  const classes = useStyles();

  return (
    <div className={className} style={style}>
      <div css={classes.container}>
        <CheeryTitle as={title?.level} variant="headline2">
          {title?.title}
        </CheeryTitle>

        {cta ? <Button css={classes.cta} {...cta} /> : null}

        <Text css={classes.description}>
          <strong>{description}</strong>
        </Text>
      </div>
    </div>
  );
};

export default TextContents;
